export const AI_PRODUCT_NAME = "Exopen AI";
